import React from 'react'

const TimeIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10.0003 1.66699C5.40533 1.66699 1.66699 5.40533 1.66699 10.0003C1.66699 14.5953 5.40533 18.3337 10.0003 18.3337C14.5953 18.3337 18.3337 14.5953 18.3337 10.0003C18.3337 5.40533 14.5953 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32449 16.667 3.33366 13.6762 3.33366 10.0003C3.33366 6.32449 6.32449 3.33366 10.0003 3.33366C13.6762 3.33366 16.667 6.32449 16.667 10.0003C16.667 13.6762 13.6762 16.667 10.0003 16.667Z"
			fill="#0087CD"
		/>
		<path
			d="M10.8337 5.83301H9.16699V10.833H14.167V9.16634H10.8337V5.83301Z"
			fill="#0087CD"
		/>
	</svg>
)

export default TimeIcon
